import React from 'react';
import { NavLink } from 'react-router-dom';

const AntSig = ({seccionContenido, ant}) => {
    const style = ant ? {paddingRight: "5px"} : {paddingLeft: "5px"};
    const link = 
    <React.Fragment>
        {!ant ? "Siguiente" : ""}
        <i className={`fa fa-arrow-circle-${ant ? "left": "right"}`} aria-hidden="true" style={style}></i>
        {ant ? "Anterior" : ""}
    </React.Fragment> 
    return ( 
        <React.Fragment>
            {
                seccionContenido ?
                <NavLink to={`/${seccionContenido.codigoSeccion}`} title={seccionContenido.tituloCompuesto}>
                    {link}
                </NavLink> :
                <span style={{color: "gray"}} title={`Estás ubicado en el ${ant ? "primer" : "último"} contenido`}>
                    {link}
                </span>
            }
        </React.Fragment> 
    );
}
 
export default AntSig;